"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROMPT = void 0;
const route_1 = require("../route");
exports.PROMPT = route_1.PROJECT.sub("/prompt");
